import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import menuItems from "@/components/common/menulist";

const withRoutes = (Content) => {
  return (props) => {
    const location = useLocation();
    const path = location.pathname;

    if (path === "/dashboard") {
      return <Content {...props} />;
    }

    const localStorageData = JSON.parse(localStorage.getItem("loginDetails"));
    const menusList = localStorageData?.userDetails?.permission || [];
    const newItem = {
      path: "/changePassword",
     path: "/attendance/adminAttendanceRegApproved",
    };
    const updatedArray = [...menusList, newItem];
    const hasMatchingSubmenu = updatedArray?.some((menuItem) => {
      if (menuItem.path === path) {
        return true;
      }
      if (menuItem.submenu && Array.isArray(menuItem.submenu)) {
        return menuItem.submenu?.some((child) => child.path === path);
      }
      return false;
    });

    return hasMatchingSubmenu ? (
      <Content {...props} />
    ) : (
      <Navigate to="/dashboard" />
    );
  };
};

export default withRoutes;
